export default function modalHandler () {
    const modals = document.querySelectorAll('[data-modal]');

    if (modals.length === 0) {
        return;
    }

    const activeClass = 'active';
    const bodyClass = 'modal-active';

    // Open modal by ID
    function openModal (modalId) {
        const modal = document.querySelector(`[data-modal="${modalId}"]`);

        if (modal) {
            modal.classList.add(activeClass);
            document.body.classList.add(bodyClass);
        }
    }

    // Close modal by ID
    function closeModal (modalId) {
        const modal = document.querySelector(`[data-modal="${modalId}"]`);

        if (modal) {
            modal.classList.remove(activeClass);
            document.body.classList.remove(bodyClass);
        }
    }

    // Close all modals
    function closeAllModals () {
        modals.forEach(modal => modal.classList.remove(activeClass));
        document.body.classList.remove(bodyClass);
    }

    // Add click event listeners to close buttons
    modals.forEach(modal => {
        const closeButton = modal.querySelector('[data-modal-close]');

        if (closeButton) {
            closeButton.addEventListener('click', () => {
                closeModal(modal.getAttribute('data-modal'));
            });
        }
    });

    // Close modals on ESC key press
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeAllModals();
        }
    });

    // Public API
    // eslint-disable-next-line consistent-return
    return {
        openModal,
        closeModal,
        closeAllModals
    };
}

// Usage example:
// Assuming the HTML structure:
// <div data-modal="modal1" class="modal">
//     <button data-modal-close>Close</button>
// </div>
// <div data-modal="modal2" class="modal">
//     <button data-modal-close>Close</button>
// </div>

// In your main JavaScript file:
// import modalHandler from './modalHandler';
// const modals = modalHandler();
//
// // Open a modal programmatically
// modals.openModal('modal1');
//
// // Close a modal programmatically
// modals.closeModal('modal1');
